module.exports = __webpack_public_path__ + "img/t4.c70d4d4d.png";